export default __webpack_public_path__ + "static/media/cp_geo_ir.84e05fc1.svg";